import React, { Fragment } from 'react';
import { Helmet } from 'react-helmet';
import InvestInAutzuTop from './InvestInAutzuTop';
import TorontoFooter from '../Layout/TorontoFooter';
import InvestMiddle from './InvestMiddle';
import InvestInAutzuBot from './InvestInAutzuBot';
import InvestTransition from './InvestInTransition';

const Investors = props => {
  const isMobile = window.innerWidth < 768;
  return (
    <Fragment>
      <Helmet>
        <title>Autzu Investors</title>
        <meta name="description" content='Autzu is a Mobility-Tech company, aiming to develop the infrastructure needed to utilize, manage and control autonomous vehicles globally. Invest in Autzu'/>
      </Helmet>
      <div className="careersPage container">
        <div className="margin-container">
          <InvestInAutzuTop isMobile={isMobile} />
          <InvestTransition/>
          <InvestMiddle isMobile={isMobile} />
          <InvestInAutzuBot isMobile={isMobile} />
        </div>
        <TorontoFooter />
      </div>
    </Fragment>
  );
};

export default Investors;



// WEBPACK FOOTER //
// ./src/components/Investors/index.js